import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FiArrowRight, FiCheck } from "react-icons/fi";
import { siteConfig } from "../Datas/productData";
import "../css/paysuccess.css";

function PaySuccess() {
  const { state } = useLocation();
  const orderNumber = state?.orderNumber || "DEMO-COMPLETE";

  return (
    <main className="success-page">
      <div className="success-page__card">
        <div className="success-page__mark" aria-hidden="true"><FiCheck /></div>
        <span className="eyebrow">Order confirmed</span>
        <h1>Thank you. We’ll take it from here.</h1>
        <p>
          Your demo order <strong>{orderNumber}</strong> has been placed. A confirmation has been prepared for {state?.email || "your email address"}.
        </p>
        {typeof state?.total === "number" && (
          <div className="success-page__total">
            <span>Order total</span>
            <strong>{siteConfig.currencySymbol}{state.total.toFixed(2)} {siteConfig.currency}</strong>
          </div>
        )}
        <div className="success-page__next">
          <div><span>01</span><p>We review and pack your order.</p></div>
          <div><span>02</span><p>Tracking is sent when it leaves the workshop.</p></div>
          <div><span>03</span><p>Wear it often and make it your own.</p></div>
        </div>
        <Link className="button button--accent" to="/shop">
          Continue shopping <FiArrowRight aria-hidden="true" />
        </Link>
      </div>
    </main>
  );
}

export default PaySuccess;
